export enum ImportRequestSettingTypes {
    allinea_importa,
    importa,
    allinea
}

export class ImportRequest {
    /**
     *
     */
    constructor() {
        this.reindex = false;
        this.condizioniCommerciali = new SettingBase();
        this.prodotti = new SettingBase();
        this.alias = new SettingBase();
        this.clienti = new SettingBase();
        this.erpListiniCondizioniCommerciali = new SettingBase();
        this.prodottiCorrelati = new SettingBase();
        this.listini = new SettingBase();
        this.documenti = new SettingBase();
    }

    reindex: boolean;
    condizioniCommerciali: SettingBase;
    prodotti: SettingBase;
    alias: SettingBase;
    clienti: SettingBase;
    erpListiniCondizioniCommerciali: SettingBase;
    prodottiCorrelati: SettingBase;
    listini: SettingBase;
    documenti: SettingBase;
}

export class SettingBase {
    /**
     *
     */
    constructor() {
        this.attivo = false;
        this.mode = ImportRequestSettingTypes.allinea_importa;
        this.force = false;
    }
    attivo: boolean;
    mode: ImportRequestSettingTypes;
    force: boolean;
}
export interface Message {
    tipo: string;
    messaggio: string;
    dettaglio: string;
    ora: string;
}
export interface ResultBase extends SettingBase {
    messaggi: Message[];
}
export interface ImportResult {
    messaggi: Message[];
    local: boolean;
    reindex: boolean;
    clienti: ResultBase;
    erpListiniCondizioniCommerciali: ResultBase;
    condizioniCommerciali: ResultBase;
    listini: ResultBase;
    prodotti: ResultBase;
    alias: ResultBase;
    prodottiCorrelati: ResultBase;
    documenti: ResultBase;
}
export interface SisasImportItem {
    id: number | null;
    importSchedulazioneId: number | null;
    request: ImportRequest;
    result: any;
    stato: number | null;
    esito: string;
    createdBy: string;
    dataCreazione: string | null;
    dataModifica: string | null;
    dataInizio: string | null;
    dataFine: string | null;
}